import * as echarts from "echarts/core";
import {TooltipComponent,
    TooltipComponentOption,
    ParallelComponent,
    ParallelComponentOption,
    VisualMapComponent,
    VisualMapComponentOption,
    LegendComponent,
    LegendComponentOption} from "echarts/components";
import { ParallelChart, ParallelSeriesOption } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import {getRandom} from "../../helpers/gerRandom";

export const activeAIDiagram = (data1: (number | string)[][], data2: (number | string)[][]):void => {
    echarts.use([
        TooltipComponent,
        ParallelComponent,
        VisualMapComponent,
        LegendComponent,
        ParallelChart,
        CanvasRenderer
    ]);
    
    type EChartsOption = echarts.ComposeOption<| TooltipComponentOption
        | ParallelComponentOption
        | VisualMapComponentOption
        | LegendComponentOption
        | ParallelSeriesOption>;
    // eslint-disable-next-line
    const chartDom = document.getElementById("aiDiagramElement")!;
    const myChart = echarts.init(chartDom);
    
    const schema = [
        {
            name: "source", index: 0, text: "Sources Extract",
        },
        {
            name: "preCheck", index: 1, text: "Data Pre-Check"
        },
        {
            name: "features", index: 2, text: "Features Extraction"
        },
        {
            name: "modeling", index: 3, text: "Modeling"
        },
        {
            name: "pattern", index: 4, text: "Pattern Calculation"
        },
        {
            name: "probability", index: 5, text: "Probability Calculation"
        },
        {
            name: "synthesis", index: 6, text: "Synthesis and Decision Making"
        },
        {
            name: "", index: 7, text: ""
        }
    ];
    
    const lineStyle = {
        width: 1,
        opacity: 0.5
    };
    // eslint-disable-next-line
    const option:EChartsOption & any = {
        parallelAxis: [
            {
                dim: 0,
                name: schema[0].text,
                inverse: true,
                nameLocation: "start",
                min: 0, max: 210
            },
            {
                dim: 1, name: schema[1].text, min: 0, max: 210
            },
            {
                dim: 2, name: schema[2].text, min: 0, max: 210
            },
            {
                dim: 3, name: schema[3].text,  min: 0, max: 210
            },
            {
                dim: 4, name: schema[4].text,  min: 0, max: 210
            },
            {
                dim: 5, name: schema[5].text ,  min: 0, max: 210
            },
            {
                dim: 6, name: schema[6].text,  min: 0, max: 210
            },
            {
                dim: 7,
                name: schema[7].text,
                type: "category",
                data: [ "Data for Reanalysis", "Market Analysis", "Forecast Scenarios"],
                axisLabel: {
                    color: "#FFF"
                }
            }
        ],
        visualMap: {
            show: false,
            min: 0,
            max: 200,
            dimension: 2,
            inRange: {
                color: ["#50a3ba", "#d94e5d", "#335833", "#4a5968", "#05080c"].reverse(),
            }
        },
        parallel: {
            top: "50px",
            left: 170,
            right: 150,
            bottom: 40,
            parallelAxisDefault: {
                type: "value",
                name: "1",
                nameLocation: "end",
                nameGap: 20,
                nameTextStyle: {
                    color: "#fff",
                    fontSize: 12
                },
                axisLine: {
                    lineStyle: {
                        color: "#aaa"
                    }
                },
                axisTick: {
                    show: false,
                    lineStyle: {
                        color: "#777"
                    }
                },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    color: "transparent"
                }
            }
        },
        series: [
            {
                name: "data1",
                type: "parallel",
                lineStyle: lineStyle,
                data: data1
            },
        ]
    };
    
    setInterval(function () {
        const randomIndex = Math.floor(Math.random() * 6);
        myChart.setOption({
            series: [
                {
                    name: "data1",
                    type: "parallel",
                    lineStyle: lineStyle,
                    data: data1.map((opt) => {
                        const newOpt = [...opt];
                        newOpt[randomIndex] = getRandom(0, 200);
                        return newOpt;
                    })
                },
                {
                    name: "data2",
                    type: "parallel",
                    lineStyle: lineStyle,
                    data: data2
                },
            ]
        });
    }, 1000);
    
    option && myChart.setOption(option);
};
